import classNames from "classnames";
import styles from "./style.module.scss";
import SkeletonLoader from "shared/components/common/skeleton";

interface CardSkeletonProps {
  count?: number;
  className?: string;
  title?: string;
  icon?: React.ReactNode;
}

const CardSkeleton = ({
  count = 1,
  className,
  title,
  icon,
}: CardSkeletonProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={classNames(styles.cardSkeleton, "grid", className)}
        >
          <div className={classNames(styles.iconSkeleton)}>
            {icon || <SkeletonLoader className={styles.iconPlaceholder} />}
          </div>

          <div className={classNames(styles.textEnclosure, "grid")}>
            {title ? (
              <h4 className={classNames(styles.title)}>{title}</h4>
            ) : (
              <SkeletonLoader className={styles.titleSkeleton} />
            )}

            <SkeletonLoader className={styles.descriptionSkeleton} />
          </div>
        </div>
      ))}
    </>
  );
};

export default CardSkeleton;
